// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6ee99aa4] .v-select__content .v-list{padding-bottom:60px !important}[data-v-6ee99aa4] .clear-all-footer{position:sticky;bottom:0;background-color:#fff;z-index:10;box-shadow:0 -2px 4px rgba(0,0,0,.1);margin-top:0 !important}.theme--dark[data-v-6ee99aa4] .clear-all-footer{background-color:#1e1e1e}", ""]);
// Exports
module.exports = exports;
